import type { FaireProductEntity } from "../../entity_types/product";

export const p_jqfb2gxg3a: FaireProductEntity = {
  token: "p_jqfb2gxg3a",
  type: "product",
  name: "Lemon Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/f24d565adf94420e257b17aef62b11ab8d7d72fa087a746b00b305383503dc50.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/903137e9654de5fb161d51934c982d9c48a7c6cc153b5f3f111ad0bbe9b3c6a1.jpeg",
    "https://cdn.faire.com/fastly/5dfe3516718fd26e57f753f33d76a603c44441a96f241363a9a2e53b674eb4f3.jpeg",
    "https://cdn.faire.com/fastly/7dbc2fc9f22abb61601877a62bf0ef47b32415f210e070d56ff76f9ee99f02d3.jpeg",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a small connection. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes® bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes® have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:35.637Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
